module.exports = __webpack_public_path__ + "media/images/flags/1x1/tls-04af653bd91e1c45448cae9f087f1c93.svg";